<style>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    /* display: none;*/
    -webkit-appearance: none;
    margin: 0;
}
</style>

<style scoped>
.content-wrapper .content {
    padding-top: 95px;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

.el-select {
    display: block;
}

.el-button--info {
    box-shadow: 0 1px 7px rgba(0, 0, 0, 0.05);
    border: 1px solid rgba(0, 0, 0, 0.04) !important;
    padding: 10px;
    background-color: white;
    color: black;
}

.el-button--info:hover {
    box-shadow: 0 1px 40px rgba(0, 0, 0, 0.05);
    border: 1px solid rgba(0, 0, 0, 0.04) !important;
    padding: 10px;
    background-color: white;
    color: black;
}

.el-input-group__prepend {
    cursor: pointer;
}

button[disabled='disabled'],
button:disabled {
    background-color: rgba(200, 200, 200, 2.3);
    cursor: not-allowed;
    border-color: rgba(200, 200, 200, 2.3);
}

.m-t-15 {
    margin-top: 15px;
}
</style>
<template>
    <!-- <transition name="el-zoom-in-top"> -->
    <div class="content-wrapper">
        <section class="content">
            <div class="box">
                <div class="box-header with-border">
                    <h3 class="box-title">Create Domain</h3>
                </div>
                <div class="box-body">
                    <form method="post" v-on:submit.prevent="onSubmit" class="form">
                        <h5>Select Publisher</h5>
                        <p>Choose publisher from the dropdown or create one by clicking +add publisher</p>
                        <div class="row">
                            <div class="col-md-9">
                                <el-select v-model="pubId" placeholder="Select" filterable @change="setPubUid()">
                                    <el-option
                                        v-for="pub in publishers"
                                        :data-id="pub.uuid"
                                        :key="pub.name"
                                        :label="pub.name"
                                        :value="pub.id"
                                    >
                                    </el-option>
                                </el-select>
                            </div>
                            <div class="col-md-3">
                                <router-link to="/admin/publisher/add" class="el-button--info m-t-15">
                                    <i class="el-icon-plus el-icon-left"></i>
                                    Create Publisher
                                </router-link>
                            </div>
                        </div>
                        <hr />
                        <div class="row">
                            <div class="col-md-9">
                                <h5>Domain URL</h5>
                                <div class="el-input el-input-group el-input-group--prepend">
                                    <div tabindex="0" class="el-input-group__prepend" title="We support BOTH !!">
                                        {{ !isSecure ? 'http://' : 'http(s)://' }}
                                    </div>
                                    <el-input
                                        class=""
                                        v-validate="'required'"
                                        data-vv-delay="200"
                                        :class="{ input: true, 'is-danger': errors.has('name') }"
                                        name="name"
                                        type="text"
                                        placeholder="Domain URL"
                                        v-model="name"
                                    ></el-input>
                                </div>
                                <span v-show="errors.has('name')" class="help is-danger">{{
                                    errors.first('name')
                                }}</span>
                            </div>
                            <div class="col-md-3">
                                <h5>Infinite Scroll?</h5>
                                <div class="m-t-15">
                                    <el-switch v-model="infinitescroll" active-color="#13ce66"></el-switch>
                                </div>
                            </div>
                        </div>

                        <hr />
                        <h5>Select DFP Account</h5>
                        <el-select
                            v-model="dfp_credentials"
                            filterable
                            placeholder="Select a DFP"
                            @change="filterNetworkList"
                        >
                            <!-- <el-option key="" label="Select a DFP" value=""></el-option> -->
                            <el-option
                                v-for="item in dfpAccounts"
                                :key="item.id"
                                :label="item.alias_name"
                                :value="item.id"
                            >
                            </el-option>
                        </el-select>
                        <hr />
                        <div v-if="dfp_credentials != undefined">
                            <h5>Select DFP Network</h5>
                            <el-select
                                v-model="dfp_network"
                                filterable
                                placeholder="Select a DFP Network"
                                @change="filterNetworkList"
                            >
                                <!-- <el-option key="" label="Select a DFP Network" value=""></el-option> -->
                                <el-option
                                    v-for="network in getDfpNetworks(dfp_credentials)"
                                    :key="network.id"
                                    :label="`${network.network_code + ' : ' + network.display_name}`"
                                    :value="network.id"
                                >
                                </el-option>
                            </el-select>
                            <hr />
                        </div>

                        <div class="row" v-if="dfp_credentials != undefined">
                            <div class="col-md-9">
                                <h5>Is MCM Enabled?</h5>
                                <el-switch
                                    active-text=""
                                    inactive-text=""
                                    active-color="#13ce66"
                                    inactive-color="#ff4949"
                                    v-model="mcm_enabled"
                                    @change="resetMCM"
                                    >Is sticky Unit?</el-switch
                                >
                            </div>
                        </div>

                        <div v-if="dfp_credentials != undefined && mcm_enabled == true" style="padding: 10px 0 20px 0">
                            <h5>Select MCM Delegation Type:</h5>
                            <el-select
                                v-model="account_type"
                                placeholder="Select MCM Delegation Type"
                                @change="filterNetworkList"
                            >
                                <el-option
                                    v-for="(mcm_account_type, id) in mcmAccountType"
                                    :data-id="id"
                                    :label="mcm_account_type.account_type.replaceAll('_', ' ')"
                                    :value="mcm_account_type.id"
                                    :key="id"
                                >
                                </el-option>
                            </el-select>
                        </div>

                        <div v-if="dfp_credentials != undefined && mcm_enabled == true">
                            <h5>Select Child DFP Network</h5>
                            <el-select
                                :disabled="account_type == null"
                                v-model="child_dfp_network"
                                filterable
                                placeholder="Select Child DFP Network"
                            >
                                <!-- <el-option key="" label="Select a DFP Network" value=""></el-option> -->
                                <el-option
                                    v-for="network in filteredAccountList"
                                    :key="network.id"
                                    :label="`${network.child_network_code + ' : ' + network.name}`"
                                    :value="network.id"
                                >
                                </el-option>
                            </el-select>
                            <hr />
                        </div>

                        <!-- Parent ad unit name and path for display -->

                        <div v-if="dfp_credentials != undefined">
                            <h5>Parent Ad Unit Id (Display)</h5>
                            <el-input
                                type="number"
                                onkeypress="return event.charCode >= 48"
                                min="1"
                                placeholder="Parent Ad Unit Id from DFP for display"
                                v-model="parentAdUnitId"
                                v-validate.initial="'required|alpha'"
                                :class="{ input: true, 'is-danger': errors.has('parentAdUnitId') }"
                            ></el-input>
                            <i v-show="errors.has('parentAdUnitId')" class="fa fa-warning"></i>
                            <span v-show="errors.has('parentAdUnitId')" class="help is-danger">{{
                                errors.first('parentAdUnitId')
                            }}</span>

                            <hr />
                        </div>

                        <div v-if="dfp_credentials != undefined">
                            <h5>Parent Ad Unit Path (Display)</h5>
                            <el-input
                                placeholder="Parent Ad Unit Code from DFP for display"
                                v-model="parentAdUnitCode"
                                v-validate="'required'"
                            ></el-input>
                            <hr />
                        </div>

                        <!-- END -->

                        <!-- Parent ad unit name and path for AMP -->

                        <div v-if="dfp_credentials != undefined">
                            <h5>Parent Ad Unit Id (AMP)</h5>
                            <el-input
                                type="number"
                                onkeypress="return event.charCode >= 48"
                                min="1"
                                placeholder="Parent Ad Unit Id from DFP for AMP"
                                v-model="parentAdUnitIdAmp"
                                v-validate.initial="'required|alpha'"
                                :class="{ input: true, 'is-danger': errors.has('parentAdUnitIdAmp') }"
                            ></el-input>
                            <i v-show="errors.has('parentAdUnitIdAmp')" class="fa fa-warning"></i>
                            <span v-show="errors.has('parentAdUnitIdAmp')" class="help is-danger">{{
                                errors.first('parentAdUnitIdAmp')
                            }}</span>

                            <hr />
                        </div>

                        <div v-if="dfp_credentials != undefined">
                            <h5>Parent Ad Unit Path(AMP)</h5>
                            <el-input
                                placeholder="Parent Ad Unit Code from DFP for AMP"
                                v-model="parentAdUnitCodeAmp"
                                v-validate="'required'"
                            ></el-input>
                            <hr />
                        </div>

                        <!-- END -->
                        <h5>Seller Id Domain</h5>
                        <div class="row">
                            <div class="col-md-9">
                                <el-select v-model="domain_id" placeholder="Select" filterable>
                                    <el-option
                                        v-for="seller in sellers"
                                        :key="seller.domain_name"
                                        :label="seller.domain_name"
                                        :value="seller.domain_id"
                                    >
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <el-checkbox v-model="gdpr_enabled">GDPR</el-checkbox>
                                <el-checkbox v-model="cpra_enabled">CPRA</el-checkbox>
                            </div>
                        </div>
                        <div class="clearfix m-t-15">
                            <button type="submit" class="el-button el-button--success" :disabled="!formValid">
                                <i class="el-icon-plus el-icon-left"></i>
                                Create Domain
                            </button>
                            <router-link to="/admin/domains/" class="el-button el-button--danger"> Cancel </router-link>
                        </div>
                    </form>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import axios from 'axios';
import { EventBus } from '../../../event-bus.js';
export default {
    data: () => {
        return {
            mcm_enabled: false,
            name: undefined,
            publishers: [],
            isSecure: true,
            pubId: undefined,
            pubUid: undefined,
            dfp_credentials: undefined,
            dfp_network: undefined,
            child_dfp_network: null,
            dfpAccounts: [],
            childDfpAccounts: [],
            mcmAccountType: [],
            parentAdUnitId: undefined,
            parentAdUnitCode: undefined,
            parentAdUnitIdAmp: undefined,
            parentAdUnitCodeAmp: undefined,
            infinitescroll: false,
            account_type: null,
            filteredAccountList: [],
            sellers: [],
            domain_id: '',
            gdpr_enabled: false,
            cpra_enabled: false,
        };
    },
    created: function () {
        axios
            .all([
                axios.get(BASE_URL + 'v1/publishers/'),
                axios.get(BASE_URL + 'v1/dfp_accounts/'),
                axios.get(BASE_URL + 'v1/child-dfp-network-list/'),
                axios.get(BASE_URL + 'v1/mcm-account-list/'),
            ])
            .then(
                axios.spread((response, dfpAccounts, childAccounts, mcm_type) => {
                    //console.log("response",response);
                    this.publishers = response.data.pub_data;
                    this.dfpAccounts = dfpAccounts.data;
                    this.childDfpAccounts = childAccounts.data;
                    this.mcmAccountType = mcm_type.data;
                    if (this.$route.query.publisher) {
                        for (let i = 0; i < this.publishers.length; i++) {
                            //console.log(this.publishers[i].id);
                            if (this.publishers[i].id == parseInt(this.$route.query.publisher)) {
                                this.pubId = parseInt(this.$route.query.publisher);
                                this.setPubUid();
                            }
                        }
                    }
                })
            );
    },
    methods: {
        filterNetworkList() {
            if (this.dfp_network && this.account_type) {
                var selectedAccount = this.mcmAccountType.filter((k) => {
                    return k.id == this.account_type;
                })[0].account_type;
                this.filteredAccountList = this.childDfpAccounts.filter((k) => {
                    return k.delegation_type == selectedAccount && k.dfp_network == this.dfp_network;
                });
                this.child_dfp_network = null;
            }
        },
        resetMCM() {
            this.account_type = null;
            this.child_dfp_network = null;
        },
        setPubUid() {
            this.domain_id = null;
            let i = 0;
            for (; i < this.publishers.length; i++) {
                if (this.publishers[i].id == this.pubId) {
                    this.pubUid = this.publishers[i].uuid;
                    //console.log(this.pubUid);
                    break;
                }
            }
            this.getSellerId();
        },
        getSellerId() {
            console.log('seller called');
            axios
                .post(BASE_URL + 'reports/v1/pub-get-dash-info/', {
                    publisherId: this.pubId,
                })
                .then((response) => {
                    if (response.data.status) {
                        this.sellers = response.data.data;
                    }
                })
                .catch((err) => {
                    console.log('err', err);
                });
        },
        onSubmit() {
            let features = {};
            if(this.cpra_enabled) features["cpra"] = "enabled"
            else if (features["cpra"] == "enabled") features["cpra"] = "disabled";
            if(this.gdpr_enabled) {
                features["gdpr"] = "enabled"
                features["additionalPrebidModules"] = "gdprEnforcement"
            }
            else if (features["gdpr"] == "enabled") features["gdpr"] = "disabled";
            axios
                .post(BASE_URL + 'v1/publishers/' + this.pubUid + '/domains/', {
                    pub_id: this.pubUid,
                    name: this.name,
                    is_secure: this.isSecure,
                    publisher: this.pubId,
                    mcm_enable: this.account_type != null ? true : false,
                    mcm: this.account_type,
                    publishers_dfp: this.pubDFP,
                    dfp_credentials: this.dfp_credentials,
                    dfp_network: this.dfp_network,
                    child_dfp_network: this.child_dfp_network,
                    parent_ad_unit_id: this.parentAdUnitId,
                    parent_ad_unit_code: this.parentAdUnitCode,
                    amp_parent_ad_unit_id: this.parentAdUnitIdAmp,
                    amp_parent_ad_unit_code: this.parentAdUnitCodeAmp,
                    infinite_scroll: this.infinitescroll,
                    seller_id_input: this.domain_id,
                    features: features,
                })
                .then((response) => {
                    this.$notify({
                        title: 'Success',
                        message: 'Successfully created a new domain',
                        type: 'success',
                    });
                    EventBus.$emit('update_logs', {});

                    setTimeout(() => {
                        this.$router.push('/admin/domains/');
                    }, 1000);
                })
                .catch((error) => {
                    this.$notify({
                        title: 'Warning',
                        message: 'Unable to create the domain',
                        type: 'warning',
                    });
                });
        },
        getDfpNetworks(dfp_credentials_id) {
            // //console.log(dfp_credentials_id);
            // //console.log(this.dfpAccounts);
            if (dfp_credentials_id) {
                for (let i = 0; i < this.dfpAccounts.length; i++) {
                    if (dfp_credentials_id == this.dfpAccounts[i].id) {
                        //console.log(this.dfpAccounts[i].networks);
                        let dfp_networks = [];
                        for (let j = 0; j < this.dfpAccounts[i].networks.length; j++) {
                            //console.log(this.dfpAccounts[i].networks[j]);
                            if (this.dfpAccounts[i].networks[j].hb_setup_done)
                                dfp_networks.push(this.dfpAccounts[i].networks[j]);
                        }
                        //console.log(dfp_networks);
                        return dfp_networks;
                    }
                }
            } else {
                return [];
            }
        },
    },
    computed: {
        formValid() {
            return (
                this.pubUid &&
                this.name &&
                this.isSecure &&
                this.pubId &&
                this.dfp_credentials &&
                this.dfp_network &&
                this.parentAdUnitId &&
                this.parentAdUnitCode &&
                (this.mcm_enabled ? (this.account_type !== null && this.child_dfp_network !== null) : true)
            );
        },
    },
};
</script>



// WEBPACK FOOTER //
// CreateDomain.vue?621bb854